// extracted by mini-css-extract-plugin
export default {"wrapper":"TaskWrapper_wrapper__W22Wm","dark":"TaskWrapper_dark__5ffSX"};